import { render, staticRenderFns } from "./ErrorAlert.vue?vue&type=template&id=4bd64607&scoped=true"
import script from "./ErrorAlert.vue?vue&type=script&lang=js"
export * from "./ErrorAlert.vue?vue&type=script&lang=js"
import style0 from "./ErrorAlert.vue?vue&type=style&index=0&id=4bd64607&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd64607",
  null
  
)

export default component.exports